export default {
  __INIT() {
    return {
      currentUser: null,
      logging: false,
      error: null,
      locationRequested: '/',
    };
  },
  AUTH__SET_CURRENT_USER(state, { payload }) {
    const currentUser = payload;
    return { ...state, currentUser };
  },
  AUTH__SEND_AUTHENTICATION(state) {
    return { ...state, logging: true };
  },
  AUTH__AUTHENTICATION_SUCCESSFULL(state, { payload }) {
    const currentUser = payload;
    return { ...state, currentUser, logging: false, error: null };
  },
  AUTH__AUTHENTICATION_FAILED(state, { payload }) {
    const error = payload || 'Couldn\'t authenticate';
    return { ...state, logging: false, error };
  },
  AUTH__LOGOUT(state) {
    return { ...state, currentUser: null, logging: false, error: null, locationRequested: '/' };
  },
  AUTH__SET_LOCATION_REQUESTED(state, { payload }) {
    const locationRequested = payload;
    return { ...state, logging: false, error: null, locationRequested };
  },
};



// WEBPACK FOOTER //
// ./src/frontend/modules/authentication/handlers.js